/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import YFSelect from '../../form/elements/YFSelect';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Tabs, Tab, Box } from '@material-ui/core';
import { LoadingOutlined, CheckCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { Layout, Row, Col, message, Modal, Spin, Button } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import { useCookies } from 'react-cookie';
import { getVehiclesDetail, calculateVehiclesPrice } from '../../api';
import EnquiryDialog from '../../components/dialog/EnquiryDialog';
import { StoreContext } from '../../context/store/storeContext';
import { SUBSCRIPTION_INFO, BROWSE_CAR } from '../../route/AppRouter';
import engine from '../../assets/icons/engine.png';
import gearshift from '../../assets/icons/gearshift.png';
import pipe from '../../assets/icons/pipe.png';
import steeringwheel from '../../assets/icons/steeringwheel.png';
import ReactHtmlParser from 'react-html-parser';
const { Content } = Layout;

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabContainer(props) {
    const tabTheme = createMuiTheme({
        palette: {
            primary: {
                main: '#f47d29',
            },
            secondary: {
                main: '#253592',
            },
        },
    });
    return (
        <ThemeProvider theme={tabTheme}>
            <Tabs value={0} {...props} indicatorColor="primary" />
        </ThemeProvider>
    );
}

const Loading = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Detail = () => {
    const history = useHistory();
    let { id } = useParams();
    const [cookies] = useCookies(['SESSION']);
    const [value, setValue] = useState(0);
    const [openEnquiry, setOpenEnquiryDialog] = useState(false);
    const [vehicle, setVehicle] = useState({});
    const [monthlyPayment, setMonthlyPayment] = useState(0);
    const [priceInfo, setPriceInfo] = useState({
        payment_card: 0,
        price: 0,
        number_of_months: 24,
        star_date: null,
        include_insurance: 1,
        km_per_month: 1600,
    });
    const [loading, setLoading] = useState({ calculat_price: false });
    const { actions } = useContext(StoreContext);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const loadInformation = () => {
        message.config({ top: 100 });
        const hide = message.loading('Loading');

        const loadAllData = [
            getVehiclesDetail({
                token: '',
                vehicle_id: id,
            }),
        ];

        Promise.all(loadAllData)
            .then((response) => {
                response.forEach((item) => {
                    if (item.vehicle_detail) {
                        setVehicle(item.vehicle_detail);
                    }
                    if (item.cards) {
                        if (item.cards.length > 0) {
                            const card_arr = [];
                            item.cards.forEach((card) => {
                                card_arr.push({
                                    id: card.id,
                                    label: card.number,
                                    value: card.id,
                                });
                            });
                        }
                    }
                });
                hide();
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        // invalid session case
                        Modal.error({
                            title: 'Unauthorize',
                            content: 'Your session is expire. please login again',
                            onOk: () => {
                                history.push('/');
                                window.location.reload(false);
                            },
                        });
                    }
                }
            });
    };

    useEffect(() => {
        if (vehicle.available_date === undefined) {
            loadInformation();
            calculatePrice();
        } else {
            calculatePrice();
        }
    }, [priceInfo]);

    const handleSelectChange = (prop) => {
        setPriceInfo({ ...priceInfo, [prop.name]: prop.value });
    };

    const calculatePrice = () => {
        message.config({ top: 100 });
        setLoading({ ...loading, calculat_price: true });
        const request = { ...priceInfo, star_date: vehicle.star_date };
        delete request.price;
        calculateVehiclesPrice({ token: '', vehicle_id: id, request })
            .then((price) => {
                const { data } = price;
                setMonthlyPayment(data);
                setLoading({ ...loading, calculat_price: false });
            })
            .catch((error) => {
                console.error(error?.response);
                message.error(error?.response?.message);
            });
    };

    const subscribeVehicle = () => {
        if (cookies.SESSION === undefined) {
            actions.dialogAction.openEntryDialog({ open: true, type: 'signin' });
        } else if (cookies.SESSION.access_token === undefined) {
            actions.dialogAction.openEntryDialog({ open: true, type: 'signin' });
        } else {
            if (priceInfo.number_of_months === 0) {
                message.error('Select duration.');
                return;
            }
            if (priceInfo.km_per_month === 0) {
                message.error('Select Kilometer per month.');
                return;
            }
            history.push({
                pathname: `${SUBSCRIPTION_INFO}`,
                search: `?vehicle_id=${id}&number_of_month=${priceInfo.number_of_months}&allowed_km_per_month=${priceInfo.km_per_month}&monthly_rate=${monthlyPayment.value}`,
                state: {
                    vehicle_id: id,
                    number_of_months: priceInfo.number_of_months,
                    allowed_km_per_month: priceInfo.km_per_month,
                    monthly_rate: monthlyPayment.value,
                },
            });
        }
    };

    const renderThumbnail = () => {
        const tumbnails = [];
        if (vehicle.images) {
            vehicle.images.forEach((image) => {
                tumbnails.push(
                    <img
                        src={image.url}
                        // className="carousel-image"
                        alt="car"
                    />
                );
            });
        }
        return tumbnails;
    };

    const searhHistory = () => {
        return {
            vehicle_id: id,
            number_of_months: priceInfo.number_of_months,
            allowed_km_per_month: priceInfo.km_per_month,
            monthly_rate: monthlyPayment.value,
        };
    };

    const back = () => {
        history.push(BROWSE_CAR);
    };

    return (
        <Content test_id="vehicle-detail" className="searchResultContainer">
            <Row className="result">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="result-left"
                >
                    <h1>{vehicle.year === undefined ? '' : `${vehicle.name}`}</h1>
                    <p className="availableDate">{`Available from ${vehicle.available_date}`}</p>
                    <br />
                    <YFSelect
                        value={priceInfo.number_of_months}
                        name="number_of_months"
                        label="Booking Duration"
                        placeholder="Select Duration"
                        options={generateMonth()}
                        handleChange={handleSelectChange}
                    />
                    <YFSelect
                        value={priceInfo.km_per_month}
                        name="km_per_month"
                        label="Kilometer per month"
                        placeholder="Select Miles"
                        options={milesPerMonth}
                        handleChange={handleSelectChange}
                    />
                    {/* <YFSelect
            name="payment_card"
            label="Payment Card"
            placeholder="Select Payment Card"
            options={cards}
            handleChange={handleSelectChange}
          /> */}
                    <div>
                        <label>Includes :</label>
                        <div className="result-left-insurance">
                            <span className="insuranceIcon">
                                <CheckCircleOutlined /> Car
                                <br />
                            </span>
                            <span className="insuranceIcon">
                                <CheckCircleOutlined /> Tax
                                <br />
                            </span>
                            <span className="insuranceIcon">
                                <CheckCircleOutlined /> Services
                                <br />
                            </span>
                            <span className="insuranceIcon">
                                <CheckCircleOutlined /> Maintenance
                                <br />
                            </span>
                            <span className="insuranceIcon">
                                <CheckCircleOutlined /> Breakdown Cover
                            </span>
                        </div>
                    </div>

                    <div className="resultCarPrice">
                        {loading.calculat_price ? (
                            <Spin indicator={Loading} size="large" />
                        ) : (
                            <>
                                {monthlyPayment.currency} {monthlyPayment.offer_price}
                                <span>/ month</span>
                            </>
                        )}
                    </div>
                    {vehicle.status === 'Ex Stock' ? (
                        <>
                            <input
                                test_id="vehicle-detail-submit"
                                type="submit"
                                value="Subscribe"
                                onClick={() => subscribeVehicle()}
                            />
                            <div className="option-text"> OR </div>
                            <input
                                test_id="vehicle-detail-enquiry"
                                className="inquiry-button primary-btn"
                                type="button"
                                value="Enquiry"
                                onClick={() => setOpenEnquiryDialog(true)}
                            />
                        </>
                    ) : (
                        <input
                            test_id="vehicle-detail-enquiry"
                            className="inquiry-button primary-btn"
                            type="button"
                            value="Enquiry"
                            onClick={() => setOpenEnquiryDialog(true)}
                        />
                    )}
                    <Row />
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 18 }}
                    xl={{ span: 18 }}
                    xxl={{ span: 18 }}
                    className="result-right"
                >
                    <div>
                        <Button type="link" icon={<LeftOutlined />} onClick={back}>
                            Browse cars
                        </Button>
                    </div>
                    <div className="result-right-carousel-container">
                        <Carousel
                            showThumbs={true}
                            renderThumbs={(item) => {
                                return renderThumbnail();
                            }}
                        >
                            {vehicle.images !== undefined &&
                                vehicle.images.map((image, key) => {
                                    return (
                                        <div className="sliderImage" key={key}>
                                            <img
                                                src={image.url}
                                                // className="carousel-image"
                                                alt="car"
                                            />
                                        </div>
                                    );
                                })}
                            {/* <div className="sliderImage">
                <img
                  src={vehicle.feature_photo}
                  // className="carousel-image"
                  alt="car"
                />
              </div>
              <div className="sliderImage">
                <img
                  src={vehicle.feature_photo}
                  // className="carousel-image"
                  alt="car"
                />
              </div> */}
                        </Carousel>
                        {/* <img
              src={vehicle.feature_photo}
              className="carousel-image"
              alt="Car"
            /> */}
                    </div>
                    <div className="result-right-vehicle-feature-container">
                        <div className="feature-item">
                            <img className="feature-image" src={steeringwheel} alt="SteeringWheel" />
                            <label className="feature-item-label">{vehicle.body_type}</label>
                        </div>
                        <div className="feature-item">
                            <img className="feature-image" src={gearshift} alt="SteeringWheel" />
                            <label className="feature-item-label">{vehicle.transmission}</label>
                        </div>
                        <div className="feature-item">
                            <img className="feature-image" src={engine} alt="SteeringWheel" />
                            <label className="feature-item-label">{vehicle.fuel_type}</label>
                        </div>
                        <div className="feature-item">
                            <img className="feature-image" src={pipe} alt="SteeringWheel" />
                            <label className="feature-item-label">{`${vehicle.seat} Seat`}</label>
                        </div>
                        {/* <div className="feature-item">
              <img
                className="feature-image"
                src={speedometer}
                alt="SteeringWheel"
              />
              <label className="feature-item-label">{vehicle.mpg} MPG</label>
            </div> */}
                        {/* {features.map(item => {
              return (
                <div className="feature-item">
                  <img className="feature-item-image" src={item.image} alt={item.name} />
                  <label className="feature-item-label">{item.name}</label>
                </div>
              );
            })} */}
                    </div>
                    <div>
                        <TabContainer value={value} onChange={handleChange} variant="standard">
                            {/* <Tab label="Description" {...a11yProps(0)} /> */}
                            <Tab label="Features" {...a11yProps(0)} />
                        </TabContainer>
                        {/* <TabPanel value={value} index={0}>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Suscipit debitis cumque quia, veniam eos dignissimos officia
                modi quod, ullam error laborum molestias nam fugiat quam, alias
                soluta. Minima, error vel!
              </p>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                natus odio dignissimos veritatis corporis eveniet nulla amet
                incidunt nobis excepturi ea id deleniti eum ex rem aperiam,
                dolorum ullam atque!
              </p>
            </TabPanel> */}
                        <TabPanel value={value} index={0}>
                            {/* <div dangerouslySetInnerHTML={{__html: vehicle.placeholder}}>
              </div> */}

                            {ReactHtmlParser(vehicle.placeholder)}

                            {/* <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
                natus odio dignissimos veritatis corporis eveniet nulla amet
                incidunt nobis excepturi ea id deleniti eum ex rem aperiam,
                dolorum ullam atque! Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Voluptatem voluptatibus nesciunt laborum
                beatae tempora similique porro, sit suscipit eaque distinctio et
                illum? Similique enim nesciunt illum placeat numquam laboriosam
                omnis! Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Ad fugit, pariatur sint atque reprehenderit, quaerat laudantium,
                veniam voluptatum tempore minima repellat doloribus labore
                veritatis voluptatibus quia dignissimos at qui aliquam!
              </p> */}
                        </TabPanel>
                    </div>
                </Col>
            </Row>
            <EnquiryDialog history={searhHistory} open={openEnquiry} handleClose={setOpenEnquiryDialog} />
        </Content>
    );
};

export default Detail;

const generateMonth = () => {
    const months = [];
    for (let index = 6; index <= 36; index++) {
        months.push({
            label: `${index} Months`,
            value: index,
        });
    }
    return months;
};

const milesPerMonth = [
    {
        label: '1600 KM',
        value: 1600,
    },
    {
        label: '2750 KM',
        value: 2750,
    },
    {
        label: '3300 KM',
        value: 3300,
    },
];
